/**
 * Smoothie King – front-end JS entry.
 * Add any block-specific front-end behavior here.
 */

import Splide from "@splidejs/splide";

// Mobile menu interactivity is owned by app-node/components/Header.jsx on the
// headless site. The classic theme no longer renders the toggle/panel.

// Trio image-style: horizontal Splide slider on mobile only.
function initTrioImageSliders() {
	const mq = window.matchMedia("(max-width: 781.98px)");
	const grids = document.querySelectorAll(
		".wp-block-smoothie-king-trio.is-style-image .trio-grid",
	);

	grids.forEach((grid) => {
		let splide = null;
		// Keep refs to original items so we can restore on teardown.
		const originalItems = Array.from(
			grid.querySelectorAll(":scope > .trio-item"),
		);

		if (originalItems.length < 2) return;

		function build() {
			if (splide) return;

			grid.classList.add("splide");

			const track = document.createElement("div");
			track.className = "splide__track";

			const list = document.createElement("ul");
			list.className = "splide__list";

			originalItems.forEach((item) => {
				const slide = document.createElement("li");
				slide.className = "splide__slide";
				slide.appendChild(item);
				list.appendChild(slide);
			});

			track.appendChild(list);
			grid.appendChild(track);

			splide = new Splide(grid, {
				type: "slide",
				perPage: 1,
				gap: "20px",
				padding: { right: "10%", left: "10%" },
				arrows: false,
				pagination: true,
				focus: 0,
				omitEnd: true,
				reducedMotion: { speed: 0, rewindSpeed: 0 },
			}).mount();
		}

		function teardown() {
			if (!splide) return;
			splide.destroy();
			splide = null;

			// Restore flat list of .trio-item children.
			const track = grid.querySelector(".splide__track");
			originalItems.forEach((item) => grid.appendChild(item));
			if (track) track.remove();
			grid.classList.remove("splide");
		}

		function onMqChange(e) {
			e.matches ? build() : teardown();
		}

		mq.addEventListener("change", onMqChange);
		if (mq.matches) build();
	});
}

function initFaqExclusiveAccordion() {
	document
		.querySelectorAll('.faq-list[data-exclusive="true"]')
		.forEach((list) => {
			list.addEventListener("click", (e) => {
				const summary = e.target.closest("summary");
				if (!summary) return;
				const opening = summary.closest("details");
				if (!opening) return;
				list.querySelectorAll("details").forEach((det) => {
					if (det !== opening && det.open) det.open = false;
				});
			});
		});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		initTrioImageSliders();
		initFaqExclusiveAccordion();
	});
} else {
	initTrioImageSliders();
	initFaqExclusiveAccordion();
}
